import * as wasm from "./ergo_lib_wasm_bg.wasm";
export * from "./ergo_lib_wasm_bg.js";